// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.svg{user-select:none;-webkit-user-select:none;display:flex}`, "",{"version":3,"sources":["webpack://./src/styles/components/svg.scss"],"names":[],"mappings":"AAAA,KACE,gBAAA,CACA,wBAAA,CACA,YAAA","sourcesContent":[".svg {\n  user-select: none;\n  -webkit-user-select: none;\n  display: flex;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
